import styled from 'styled-components';

export const ReviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-large);
  width: 82vw;
  max-width: 360px;
  height: fit-content;
  min-height: 100%;
  padding: var(--spacing-base);
  background: var(--grey-50);
  border-radius: var(--radius-large);

  @media (width >= 48rem) {
    width: 377px;
    height: 370px;
    padding: var(--spacing-large);
    background: var(--grey-100);
  }

  & h2 {
    font-size: var(--font-size-text-xl);
    font-weight: var(--font-weight-xbold);
    line-height: 23px;
    color: var(--black);
  }

  & time {
    font-size: var(--font-size-text-md);
    font-weight: var(--font-weight-bold);
    line-height: 23px;
    color: var(--black);
  }
`;

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;

  & h3 {
    font-size: var(--font-size-text-md);
    font-weight: var(--font-weight-bold);
    line-height: 23px;
    color: var(--black);
  }

  & > div {
    font-size: var(--font-size-text-md);
    font-weight: var(--font-weight-regular);
    line-height: 23px;
    color: var(--black);
  }
`;

export const Ratings = styled.div`
  display: flex;
  flex-direction: horizontal;
  align-items: center;
  gap: 2px;
`;

export const Rating = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
  width: 18px;
  height: 18px;
  padding: 1px;
  background: var(--success-500);

  & svg {
    fill: var(--white);
    stroke: var(--success-800);
    width: 24px;
    height: 24px;
  }
`;
